
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.3 8.2h29.5V23H2.2l.1-14.8z","stroke":"#47AEA6","stroke-width":"2","stroke-miterlimit":"10","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M25.4 23.3l-3.9-4.2c.8-1 1.2-2.2 1.2-3.5 0-3.1-2.6-5.7-5.7-5.7s-5.7 2.6-5.7 5.7 2.6 5.7 5.7 5.7c1.1 0 2.1-.3 3-.9l3.9 4.2c.2.2.5.3.7.3.2 0 .5-.1.7-.3.5-.2.5-.9.1-1.3zm-12-7.7c0-2 1.7-3.7 3.7-3.7s3.7 1.7 3.7 3.7c0 1.1-.5 2.1-1.2 2.7-.6.6-1.5.9-2.4.9-2.1.1-3.8-1.6-3.8-3.6z","fill":"#F9A91E"}})])
          )
        }
      }
    